import React from "react";
import withLocalization from "../../../../hoc/with-localization";
import inpSetts from "../../../../settings/params-settings";
import STDepression from "./ST-depression-editor";
import STElevation from "./ST-elevation-editor";
import TransZoneEditor from "../trans-zone-editor";
import IndexSokolovEditor from "../index-sokolov-lyon-editor";

const maxST = inpSetts.ST.max_mV * 1000;
const minST = inpSetts.ST.min_mV * 1000;

const STEditor = props => {
    const {
        loc,
        onChanged,
        data: { STDeprTo_uV, STElevTo_uV, transZone, indexSokolovLyon }
    } = props;

    return (
        <div className="ctrl-container ctrl-container-ST">
            <div className="ctrl-block">
                <STDepression loc={loc} onChanged={onChanged} data={{ STDeprTo_uV }} minST={minST} maxST={maxST} />
                <STElevation loc={loc} onChanged={onChanged} data={{ STElevTo_uV }} minST={minST} maxST={maxST} />
            </div>
            <div className="ctrl-block">
                <TransZoneEditor loc={loc} onChanged={onChanged} data={{ transZone }} />
                <IndexSokolovEditor loc={loc} onChanged={onChanged} data={{ indexSokolovLyon }} />
            </div>
        </div>
    );
};

export default withLocalization(STEditor);
